import React from 'react';
import './style.scss'

const LoadingSpinner = () => (
  <div className="loadingSpinner">
    <div className="loader">Loading...</div>
  </div>
)

export default LoadingSpinner